import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const funnel_url = 'https://www.quickclosehomeoffer.com/home/';

  return (
    <header className="fixed w-full bg-white/95 backdrop-blur-sm z-50 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          <Link to="/" className="flex items-center hover:opacity-80 transition-opacity">
            <img
              src="/quick-close-png2.png"
              alt="Quick Close Home Offers"
              className="h-14 w-auto"
            />
          </Link>

          <div className="hidden lg:flex items-center gap-8">
            <Link to="/" className="text-gray-700 hover:text-blue-900 transition-colors text-sm font-medium">
              Home
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-blue-900 transition-colors text-sm font-medium">
              About
            </Link>
            <Link to="/how-it-works" className="text-gray-700 hover:text-blue-900 transition-colors text-sm font-medium">
              How It Works
            </Link>
            <Link to="/comparison" className="text-gray-700 hover:text-blue-900 transition-colors text-sm font-medium">
              Why Us
            </Link>
            <Link to="/reviews" className="text-gray-700 hover:text-blue-900 transition-colors text-sm font-medium">
              Reviews
            </Link>
            <Link to="/faq" className="text-gray-700 hover:text-blue-900 transition-colors text-sm font-medium">
              FAQ
            </Link>
            <a
              href={funnel_url}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-900 text-white px-6 py-2.5 rounded-lg hover:bg-blue-950 transition-colors font-semibold"
            >
              Get An Offer
            </a>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-gray-700 hover:text-blue-900"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isOpen && (
          <div className="lg:hidden pb-4 space-y-2">
            <Link
              to="/"
              className="block px-3 py-2 text-gray-700 hover:text-blue-900 hover:bg-gray-50 rounded-lg text-sm font-medium"
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/about"
              className="block px-3 py-2 text-gray-700 hover:text-blue-900 hover:bg-gray-50 rounded-lg text-sm font-medium"
              onClick={() => setIsOpen(false)}
            >
              About
            </Link>
            <Link
              to="/how-it-works"
              className="block px-3 py-2 text-gray-700 hover:text-blue-900 hover:bg-gray-50 rounded-lg text-sm font-medium"
              onClick={() => setIsOpen(false)}
            >
              How It Works
            </Link>
            <Link
              to="/comparison"
              className="block px-3 py-2 text-gray-700 hover:text-blue-900 hover:bg-gray-50 rounded-lg text-sm font-medium"
              onClick={() => setIsOpen(false)}
            >
              Why Us
            </Link>
            <Link
              to="/reviews"
              className="block px-3 py-2 text-gray-700 hover:text-blue-900 hover:bg-gray-50 rounded-lg text-sm font-medium"
              onClick={() => setIsOpen(false)}
            >
              Reviews
            </Link>
            <Link
              to="/faq"
              className="block px-3 py-2 text-gray-700 hover:text-blue-900 hover:bg-gray-50 rounded-lg text-sm font-medium"
              onClick={() => setIsOpen(false)}
            >
              FAQ
            </Link>
            <a
              href={funnel_url}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full mt-3 bg-blue-900 text-white px-3 py-2.5 rounded-lg hover:bg-blue-950 text-center text-sm font-semibold"
              onClick={() => setIsOpen(false)}
            >
              Get An Offer
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
